import React from 'react'
import { useFilters } from '../../context/FiltersContext'
import classnames from 'classnames'
import { capitalizeFirstLetter } from '../../utils'
import { ColourFilters } from './ColourFilters'
import { Clearfix } from '../Clearfix'

export const ColourCategoryContent: React.FC = () => {
  const { activeCategories, filters, toggleCategory } = useFilters()

  const category = 'colour'
  const currentFilters = filters[category]
  const active = activeCategories.has(category)

  const className = classnames('refineby-filters', `__${category}`, {
    __active: active,
  })

  const toggle = () => toggleCategory(category)

  return (
    <div key={category} className={className}>
      <p data-type={category} onClick={toggle} className="refineby-subtitle">
        {capitalizeFirstLetter(category.split('-').join(' '))}
      </p>
      <div data-type={category} className="refineby-filterwrap">
        {Object.keys(currentFilters).map(filter => (
          <ColourFilters key={filter} topFilter={filter} />
        ))}
        <Clearfix />
      </div>
    </div>
  )
}
